export const Incidents = {
  path: '/incidents',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'incidents',
      component: () => import('pages/incidents/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'インシデント一覧',
      },
    },
    {
      path: ':id',
      name: 'incidents-id',
      component: () => import('pages/incidents/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: 'インシデント一覧',
            path: '/incidents',
            condition: 'incident',
          },
        ],
      },
    },
  ],
};
